/* tslint:disable */
/* eslint-disable */
/**
 * FancyAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerSnapshotFromJSON, GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerSnapshotToJSON, } from './GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerSnapshot';
/**
 * @export
 */
export const GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerOperationEnum = {
    Addition: 'addition',
    Subtraction: 'subtraction',
    Multiplication: 'multiplication',
    Division: 'division',
    Fractions: 'fractions',
    IntegerAdditionSubtraction: 'integer_addition_subtraction',
    IntegerMultiplicationDivision: 'integer_multiplication_division'
};
/**
 * Check if a given object implements the GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInner interface.
 */
export function instanceOfGetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInner(value) {
    if (!('operation' in value) || value['operation'] === undefined)
        return false;
    return true;
}
export function GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerFromJSON(json) {
    return GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerFromJSONTyped(json, false);
}
export function GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'operation': json['operation'],
        'snapshot': json['snapshot'] == null ? undefined : GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerSnapshotFromJSON(json['snapshot']),
    };
}
export function GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'operation': value['operation'],
        'snapshot': GetSubjectProductSessionsR200ResponseInnerMetadataOneOf13ContentsSnapshotsInnerSnapshotToJSON(value['snapshot']),
    };
}
